var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelStyle" },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "CEP:",
                  content: _vm.dadosJson.contato.cep || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Estado:",
                  content: _vm.dadosJson.contato.estado || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Logradouro:",
                  content: _vm.dadosJson.contato.logradouro || "-"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Bairro:",
                  content: _vm.dadosJson.contato.bairro || "-"
                }
              }),
              _c("app-display", { attrs: { label: "Telefones:" } }),
              _c(
                "ul",
                _vm._l(_vm.dadosJson.contato.telefones, function(telefone) {
                  return _c("li", { key: telefone }, [_vm._v(_vm._s(telefone))])
                }),
                0
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ddfb9d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddfb9d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/ContatoUc.vue
// module id = null
// module chunks = 